import Alpine from "alpinejs";

Alpine.data("heroBanner", () => ({
  currentSlide: 0,
  touchStartX: 0,
  swipeThreshold: 50,

  transitions: {
    'x-transition:enter': "transition ease-out duration-200",
    'x-transition:enter-start': "opacity-0",
    'x-transition:enter-end': "opacity-100",
    'x-transition:leave': "transition ease-in duration-200",
    'x-transition:leave-start': "opacity-100",
    'x-transition:leave-end': "opacity-0"
  },

  get numberOfSlides() {
    return this.$root.children[0].children.length;
  },

  isActiveSlide(index) {
    return this.currentSlide === index;
  },

  touchStart(event) {
    this.touchStartX = event.touches[0].clientX;
  },

  touchEnd(event) {
    let touchEndX = event.changedTouches[0].clientX;
    if (this.touchStartX - touchEndX > this.swipeThreshold) {
      this.nextSlide();
    } else if (touchEndX - this.touchStartX > this.swipeThreshold) {
      this.previousSlide();
    }
  },

  previousSlide() {
    this.currentSlide = (this.currentSlide - 1 + this.numberOfSlides) % this.numberOfSlides;
  },

  nextSlide() {
    this.currentSlide = (this.currentSlide + 1) % this.numberOfSlides;
  },

  goToSlide(index) {
    this.currentSlide = index;
  },
}));
